module.exports = __webpack_public_path__ + "static/media/logo3.8c6e026b.jpg";